/*
 * Module for Attribute list administration
 */
define([
  "marionette",
  "messaging/messenger",
  "backbone",
  "./attributesView",
  "modules/shared/sortableList/sortableListModule",
  "./attributeTypeModel",
  "./attributesModal/attributesModalModule",
], function (
  Marionette,
  Messenger,
  Backbone,
  AttributesView,
  SortableListModule,
  AttributeTypeModel,
  AttributesModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "Attributes";
      this.region = options.region;
      this._setUpVents();
    },

    show: function () {
      //set no-op save
      Messenger.onSave(function () {
        Messenger.saveAttempted(true);
      }, this);

      this.layout = new AttributesView.attributesView();
      var activeKb = Messenger.reqres.request("active:kb");
      this.attributes = Messenger.reqres.request("kb:attributes", activeKb);

      var headers = Messenger.reqres.request("kb:attributes:list:headers");
      var extendedEvents = {
        "click .deleteAttribute": function () {
          Messenger.yesNoDialog(
            "admin.attributes.confirmDeleteAttribute",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Attribute",
                  id: this.model.id,
                  idType: "Attribute",
                  object: "Attribute",
                });
                this.model.deleteModel();
              },
            },
            this,
          );
        },
      };

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          extendedEvents: extendedEvents,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
        }),
      );

      this.layout.on(
        "add:attribute",
        function () {
          var newAttribute = this.attributes.addItem();
          Messenger.vent.trigger(
            "show:modal",
            AttributesModalModule,
            {
              editMode: false,
            },
            newAttribute,
            {
              title: "admin.attributes.addAttributes",
              closeOnBackgroundClick: false,
              modalWidth: 500,
              trackInteraction: {
                action: "Add Attribute",
                object: "Attribute",
              },
            },
          );
        },
        this,
      );

      this.attributes.onSynced(function () {
        this.layout.on(
          "show",
          function () {
            this.list.show(this.attributes);
          },
          this,
        );
        this.showRegion(this.layout);
      }, this);
    },

    _setUpVents: function () {
      Messenger.vent.on(
        "show:authoring:admin:attributes",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/attributes");
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:admin:attributes",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/attributes");
          this.show();
        },
        this,
      );

      Messenger.vent.on(
        this.name + ":selected:row",
        function (model) {
          Messenger.vent.trigger(
            "show:modal",
            AttributesModalModule,
            {
              editMode: true,
            },
            model,
            {
              title: "admin.attributes.updateAttribute",
              closeOnBackgroundClick: false,
              modalWidth: 500,
              trackInteraction: {
                action: "Edit Attribute",
                id: model.id,
                idType: "Attribute",
                object: "Attribute",
              },
            },
          );
        },
        this,
      );
    },
  });
});
